/**
 * Copyright (c) 2025 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { ContextualHelp } from '../form/ContextualHelpList/ContextualHelpList';
import { InputConfig } from '../form/TaskInputs/types';
import { Message } from '../form/TaskMessages/messageTypes';

export const DEVICE_SETUP_TEMPLATE = {
  type: 'deviceSetup',
  title: 'Device Setup',
  inputs: [
    {
      id: 'video_input',
      type: 'video_input',
      required: true,
    },
    {
      id: 'audio_input',
      type: 'audio_input',
      required: true,
    },
    {
      id: 'audio_output',
      type: 'audio_output',
      required: true,
    },
    {
      id: 'network_connection',
      type: 'network_connection',
      required: true,
      showDeviceCompatibilityStatus: true,
    },
  ] as InputConfig[],
  messages: [
    {
      display: 'Test your set up.',
      type: 'simple',
      headingType: 'primaryHeading',
    },
    {
      display: 'Make sure your device settings are working properly.',
      type: 'simple',
      headingType: 'secondaryHeading',
    },
  ] as Message[],
  contextualHelps: [
    {
      textScreenId: 'DEVICE_SETUP',
    },
  ] as ContextualHelp[],
  customProps: {
    videoAuthToken: '',
    videoProvider: '',
    testSessionId: '',
  },
};
